import React from 'react';
import { FileTextIcon, UsersIcon, StarIcon, HeartIcon } from 'lucide-react';
export const SocialProof: React.FC = () => {
  return <section className="bg-white border-b border-gray-200 pb-12" data-id="element-240">
      <div className="bg-green-50 py-3 px-4 mb-10" data-id="element-241">
        <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-242">
          <div className="flex -space-x-3" data-id="element-243">
            {[1, 2, 3, 4, 5].map(i => <img key={i} src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="Profesor" className="w-10 h-10 rounded-full border-2 border-white" data-id="element-244" />)}
          </div>
          <p className="font-semibold text-green-800 text-center sm:text-left" data-id="element-245">
            Ya elegido por 2.847+ profesores de folclore en toda Argentina
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 max-w-6xl" data-id="element-246">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-247">
          <div className="flex flex-col items-center p-6 rounded-2xl bg-gray-50" data-id="element-248">
            <div className="w-16 h-16 rounded-full bg-blue-50 flex items-center justify-center mb-4" data-id="element-249">
              <FileTextIcon className="w-8 h-8 text-blue-600" data-id="element-250" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-251">300+</h3>
            <p className="text-gray-600 text-center" data-id="element-252">Recursos digitales</p>
          </div>

          <div className="flex flex-col items-center p-6 rounded-2xl bg-gray-50" data-id="element-253">
            <div className="w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center mb-4" data-id="element-254">
              <UsersIcon className="w-8 h-8 text-orange-600" data-id="element-255" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-256">2.8k+</h3>
            <p className="text-gray-600 text-center" data-id="element-257">Profesores activos</p>
          </div>

          <div className="flex flex-col items-center p-6 rounded-2xl bg-gray-50" data-id="element-258">
            <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mb-4" data-id="element-259">
              <StarIcon className="w-8 h-8 text-green-600 fill-current" data-id="element-260" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-261">4.9/5</h3>
            <p className="text-gray-600 text-center" data-id="element-262">Valoración media</p>
          </div>

          <div className="flex flex-col items-center p-6 rounded-2xl bg-gray-50" data-id="element-263">
            <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mb-4" data-id="element-264">
              <HeartIcon className="w-8 h-8 text-red-600 fill-current" data-id="element-265" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-266">100%</h3>
            <p className="text-gray-600 text-center" data-id="element-267">Satisfacción</p>
          </div>
        </div>
      </div>
    </section>;
};